import React, {useState, useEffect} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {InputLabel,FormControl,Select as MaterialSelect  ,Box,  
  TextareaAutosize ,TextField,RadioGroup,FormControlLabel,Radio,
  TableRow, TableCell, TableContainer,Table, TableHead, TableBody
  } from '@material-ui/core';
import axios from 'axios';
import qs from 'qs';
import {toast} from "react-toastify";
import { useHistory } from "react-router-dom";
import Relojes from './Relojes4'
import Modal from './Modal';
import moment from 'moment';
import {llamaApiCargaToken,ErrorGeneral } from '../funciones/ClienteAxios';
const useStyles = makeStyles((theme) => ({
    root: {
      '& > *': {
        margin: theme.spacing(1),
        width: '20ch',
      }, 
      formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
      },
      selectEmpty: {
        marginTop: theme.spacing(2),
      },
      Textnumero: {
        width: 5+"px",
      },
      formControlFull: {
        //margin: theme.spacing(1),
        //minWidth: 120,
        width:5+"rem"
      },
    },  
    row: {
      width: '100%',         
    },
    tablaContainer: {      
      //maxHeight: window.innerHeight-480,    
      minHeight: 180,      
    },
  }));

const EditarCierre = ({modalAbierto, setModalAbierto, titulo, bitacora, bitacoraTotales, setBitacoraTotales, Bucle, finicio,listUsu, setListUsu}) => {
  let history = useHistory();
  const classes = useStyles();
  const source = axios.CancelToken.source();   
  let colorFuente = "#51ad32"   
  const limitNumber=6
  const [espera,setEspera]= useState(false);
  const [mensaje, setMensaje] = useState('');
  const [tipoAdvertencia, setTipoAdvertencia] = useState('success');
  const [aviso, setAviso] = useState(false);
  const [listTotUsu, setListTotUsu] = useState([]);
  const [listUbicacion, setListUbicacion] = useState([]);
  const [usuarios, setUsuarios] = useState({estacion1:"1", tp0Est1:0, tp1Est1:0, tp2Est1:0, tp3Est1:0, tp4Est1:0,
     estacion2:"2", tp0Est2:0, tp1Est2:0, tp2Est2:0, tp3Est2:0, tp4Est2:0,
     estacion3:"3A", tp0Est3:0, tp1Est3:0, tp2Est3:0, tp3Est3:0, tp4Est3:0
   });
  const [totUsu, setTotUsu] = useState({ tp0Tot:0, tp1Tot:0, tp2Tot:0, tp3Tot:0, tp4Tot:0,})
  //const [] =usuarios
  const [horaCierre,guardarHoraCierre]= useState({Horario:'', Cabinas:0, Pinzas:0, Incidencia:''});
  const {Horario, Cabinas, Pinzas, Incidencia}=horaCierre

  useEffect(()=>{ 
    const {Cabinas, Pinzas, Incidencia, HorarioFin} = bitacoraTotales    
    guardarHoraCierre({
      ...horaCierre,
      Horario: 'Thu Jun 17 2021 '+HorarioFin+' GMT-0500 (hora de verano central)' ,
      Cabinas:Cabinas,Pinzas:Pinzas, Incidencia:Incidencia
      //Tiempo:'Thu Jun 17 2021 '+tiempoOp+' GMT-0500 (hora de verano central)',    
    })

   

    //console.log(horaA);
    getListUbicacion()
    //getListTotUsu()  

    return ()=> {
      source.cancel();
    }  
    
  },[]);

  useEffect(()=>{ 
    let auxArr =[], nvoVal1=0, nvoVal2=0, nvoVal3=0
    let nvoVal4=0, nvoVal5=0     
    const val1= parseInt(usuarios[`tp0Est1`] )        
      
    if (typeof val1 ==="number" && !isNaN(val1) ) {
      nvoVal1+= val1 
    }

    const val2=parseInt(usuarios[`tp1Est1`]      )
    if (typeof val2 ==="number"&& !isNaN(val2)) {
      nvoVal2+= val2 
    }
    const val3=parseInt(usuarios[`tp2Est1`])      
    if (typeof val3 ==="number"&& !isNaN(val3)) {
      nvoVal3+= val3 
    }
    const val4=parseInt(usuarios[`tp3Est1`])      
    if (typeof val4 ==="number"&& !isNaN(val4)) {
      nvoVal4 += val4
    }
    const val5=parseInt(usuarios[`tp4Est1`])      
    if (typeof val5 ==="number"&& !isNaN(val5)) {
      nvoVal5+= val5
    }
    
    const val6= parseInt(usuarios[`tp0Est2`]    )    
      
    if (typeof val6 ==="number"&& !isNaN(val6)) {
      nvoVal1+= val6
    }

    const val7=parseInt(usuarios[`tp1Est2`]      )
    if (typeof val7 ==="number"&& !isNaN(val7)) {
      nvoVal2 += val7 
    }
    const val8=parseInt(usuarios[`tp2Est2`])      
    if (typeof val8 ==="number"&& !isNaN(val8)) {
      nvoVal3+= val8 
    }
    const val9=parseInt(usuarios[`tp3Est2`])      
    if (typeof val9 ==="number"&& !isNaN(val9)) {
      nvoVal4 += val9
    }
    const val10=parseInt(usuarios[`tp4Est2`])      
    if (typeof val10 ==="number"&& !isNaN(val10)) {
      nvoVal5 += val10
    }
    
    const val11= parseInt(usuarios[`tp0Est3`]    )    
      
    if (typeof val11 ==="number" && !isNaN(val11)) {
      nvoVal1 += val11 
    }

    const val12=parseInt(usuarios[`tp1Est3`]      )
    if (typeof val12 ==="number" && !isNaN(val12)) {
      nvoVal2 += val12 
    }
    const val13=parseInt(usuarios[`tp2Est3`])      
    if (typeof val13 ==="number" && !isNaN(val13)) {
      nvoVal3 += val13 
    }
    const val14=parseInt(usuarios[`tp3Est3`])      
    if (typeof val14 ==="number" && !isNaN(val14)) {
      nvoVal4 += val14
    }
    const val15=parseInt(usuarios[`tp4Est3`])      
    if (typeof val15 ==="number" && !isNaN(val15)) {
      nvoVal5 += val15
    }
    auxArr= {tp0Tot:nvoVal1, tp1Tot:nvoVal2, tp2Tot:nvoVal3, tp3Tot:nvoVal4, tp4Tot:nvoVal5}            
    
    setTotUsu(auxArr)
    
  },[usuarios]);  

  const  valInpNumber=(campo)=>{
    const valor=parseInt(campo)      
    let respuesta= false
    if (typeof valor ==="number" && !isNaN(valor) 
      && (campo!== "" || campo!== " ") ) {
      
      respuesta=true
    }
    return respuesta
  }
 
  const valListUsu=()=>{
    let respuesta = true
    
    if (respuesta && !valInpNumber(usuarios[`tp0Est1`]) ) {
      respuesta = false
    }    
    if (respuesta && !valInpNumber(usuarios[`tp1Est1`]) ) {
      respuesta = false
    }
    if (respuesta && !valInpNumber(usuarios[`tp2Est1`]) ) {
      respuesta = false
    }
    if (respuesta && !valInpNumber(usuarios[`tp3Est1`]) ) {
      respuesta = false
    }
    if (respuesta && !valInpNumber(usuarios[`tp4Est1`]) ) {
      respuesta = false
    }
    if (respuesta && !valInpNumber(usuarios[`tp0Est2`]) ) {
      respuesta = false
    }
    if (respuesta && !valInpNumber(usuarios[`tp1Est2`]) ) {
      respuesta = false
    }
    if (respuesta && !valInpNumber(usuarios[`tp2Est2`]) ) {
      respuesta = false
    }    
    if (respuesta && !valInpNumber(usuarios[`tp3Est2`]) ) {
      respuesta = false
    }    
    if (respuesta && !valInpNumber(usuarios[`tp4Est2`]) ) {
      respuesta = false
    }        
    if (respuesta && !valInpNumber(usuarios[`tp0Est3`]) ) {
      respuesta = false
    }
    if (respuesta && !valInpNumber(usuarios[`tp1Est3`]) ) {
      respuesta = false
    }
    if (respuesta && !valInpNumber(usuarios[`tp2Est3`]) ) {
      respuesta = false
    }    
    if (respuesta && !valInpNumber(usuarios[`tp3Est3`]) ) {
      respuesta = false
    }    
    if (respuesta && !valInpNumber(usuarios[`tp4Est3`]) ) {
      respuesta = false
    }    
    if (!respuesta) {
      mostrarAlertas("Debe llenar los Campos de Usuarios con un valor de 0 o mayor")
    }        
    return respuesta
  }

  const getListTotUsu=( )=>{
   
    const auxF=moment(finicio).format("YYYY-MM-DD")
    const auxU = `/usrexento/terminal`;               
    const idusu= localStorage.getItem('UsuId'); 
    const dataInfo = qs.stringify({                        
      'usuario':idusu,
      'fecha':`${auxF}T00:00:00`,      
      'terminal':Bucle,
      'idDispositivo':'987gyubjhkkjh'
    });      
    function respuesta(aux) {
      if (aux) 
      {                                                                         
        setListTotUsu(aux) 
        setUsuarios({...usuarios, estacion1:aux[0].nom, tp0Est1:aux[0].tp0, 
          tp1Est1:aux[0].tp1, tp2Est1:aux[0].tp2, tp3Est1:aux[0].tp3, tp4Est1:aux[0].tp4,
          estacion2:aux[1].nom, tp0Est2:aux[1].tp0, tp1Est2:aux[1].tp1, tp2Est2:aux[1].tp2, tp3Est2:aux[1].tp3, tp4Est2:aux[1].tp4,
          estacion3:aux[2].nom, tp0Est3:aux[2].tp0, tp1Est3:aux[2].tp1, tp2Est3:aux[2].tp2, tp3Est3:aux[2].tp3, tp4Est3:aux[2].tp4})
      }               
    }
    llamaApiCargaToken(dataInfo, auxU,respuesta,ErrorGeneral,setEspera,history,source);                 
  }

  const registrarCierre=(auxHFin)=>{
            
    const auxU = `/bitacora/cierre/edit`;               
    const idusu = localStorage.getItem('UsuId'); 
    const dataInfo = qs.stringify({                  
      'bitacora':bitacora,
      'usuario':idusu,
      'fechaTermino':auxHFin,
      'cabina':Cabinas,
      'pinza':Pinzas,
      'userNormal':0,
      'userExento':0,
      'incidencia':Incidencia,
      'idDispositivo':'987gyubjhkkjh'
    });      
    function respuesta(aux) {
      if (aux.respuesta==1) 
      {                                                                 
        //console.log(aux);
        let mensaje="Se registro correctamente el Cierre "
        toast.success(mensaje, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setModalAbierto(false)
        setTipoAdvertencia("success")      
        setMensaje(mensaje);
        setAviso(true)          
        setBitacoraTotales({
          ...bitacoraTotales,
          Cabinas:Cabinas,Pinzas:Pinzas ,
          Incidencia:Incidencia,HorarioFin:auxHFin,Vueltas:aux.vuelta,Recorrido:aux.recorrido
          
        })               
      }               
    }
    llamaApiCargaToken(dataInfo, auxU,respuesta,ErrorGeneral,setEspera,history,source);                 
  }

  const setEditUsu =( arrUsu)=>{    
    //const auxH=new Date()
    const hoy=moment(finicio).format("YYYY-MM-DD")
    const auxU = `/usrexento/terminal/edit`;               
    const idusu = localStorage.getItem('UsuId');       
    
    const dataInfo = qs.stringify({                        
      'Usuario':idusu,
      'Fecha': `${hoy}T00:00:00`,
      'Terminal':Bucle,
      'Cambio':JSON.stringify(arrUsu),
      'idDispositivo':'987gyubjhkkjh'
    });      
    function respuesta(aux) {
      if (aux.length!==0) 
      {                                                                 
        //console.log(aux);
        const mensaje="Se edito correctamente los Usuarios "
        toast.success(mensaje, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        
          setListUsu({...listUsu, Usuarios:aux.keyTp0, Exentos:aux.keyTpExe})          
        
      }               
    }
    if (arrUsu.length !== 0 ) {
     
     setTimeout(() => {
      llamaApiCargaToken(dataInfo, auxU,respuesta,ErrorGeneral,setEspera,history,source);
     }, 500); 
    }                 
  }

  const obtnUsu=()=>{
    let auxCambio =[], auxCambio2 =[], auxCambio3 =[] 
    let nvArrCam=[]
    listTotUsu.forEach((element)=>{
      if (element.nom===usuarios.estacion1) {
        if (element.tp0 !== usuarios.tp0Est1) {
          auxCambio={...auxCambio, tp0:usuarios.tp0Est1 }
        }
        if (element.tp1 !== usuarios.tp1Est1) {
          auxCambio={...auxCambio, tp1:usuarios.tp1Est1 }
        }
        if (element.tp2 !== usuarios.tp2Est1) {
          auxCambio={...auxCambio, tp2:usuarios.tp2Est1 }
        }
        if (element.tp3 !== usuarios.tp3Est1) {
          auxCambio={...auxCambio, tp3:usuarios.tp3Est1 }
        }
        if (element.tp4 !== usuarios.tp4Est1) {
          auxCambio={...auxCambio, tp4:usuarios.tp4Est1 }
        }
        if (auxCambio.length!==0) {
          auxCambio={estacion:listTotUsu[0].estacion,...auxCambio}
        }
      }
      if (element.nom===usuarios.estacion2) {
        if (element.tp0 !== usuarios.tp0Est2) {
          auxCambio2={...auxCambio2, tp0:usuarios.tp0Est2 }
        }
        if (element.tp1 !== usuarios.tp1Est2) {
          auxCambio2={...auxCambio2, tp1:usuarios.tp1Est2 }
        }
        if (element.tp2 !== usuarios.tp2Est2) {
          auxCambio2={...auxCambio2, tp2:usuarios.tp2Est2 }
        }
        if (element.tp3 !== usuarios.tp3Est2) {
          auxCambio2={...auxCambio2, tp3:usuarios.tp3Est2 }
        }
        if (element.tp4 !== usuarios.tp4Est2) {
          auxCambio2={...auxCambio2, tp4:usuarios.tp4Est2 }
        }
        if (auxCambio2.length!==0) {
          auxCambio2={estacion:listTotUsu[1].estacion,...auxCambio2}
        }
      }
      if (element.nom===usuarios.estacion3) {
        if (element.tp0 !== usuarios.tp0Est3) {
          auxCambio3={...auxCambio3, tp0:usuarios.tp0Est3 }
        }
        if (element.tp1 !== usuarios.tp1Est3) {
          auxCambio3={...auxCambio3, tp1:usuarios.tp1Est3 }
        }
        if (element.tp2 !== usuarios.tp2Est3) {
          auxCambio3={...auxCambio3, tp2:usuarios.tp2Est3 }
        }
        if (element.tp3 !== usuarios.tp3Est3) {
          auxCambio3={...auxCambio3, tp3:usuarios.tp3Est3 }
        }
        if (element.tp4 !== usuarios.tp4Est3) {
          auxCambio3={...auxCambio3, tp4:usuarios.tp4Est3 }
        }
        if (auxCambio3.length!==0) {
          auxCambio3={estacion:listTotUsu[2].estacion,...auxCambio3}
        }
      }
    })
    
    if (auxCambio.length!==0) {
      nvArrCam.push(auxCambio)
    }
    if (auxCambio2.length!==0) {
      nvArrCam.push(auxCambio2)
    }
    if (auxCambio3.length!==0) {
      nvArrCam.push(auxCambio3)
    }
    return nvArrCam
  }

  function getListUbicacion() {
    const auxUbi= JSON.parse(localStorage.getItem('LisUbic'));            
    let auxArre=[];
    auxUbi.map((ubica) => {
      if (ubica.LugarId === 1 && (ubica.Terminal.search(Bucle ) !== -1)) 
      {
        auxArre.push({ value : ubica.Id, label :ubica.Tipo })  
      }            
    })            
    setListUbicacion(auxArre)
  }

  const onChange = e =>
  { let expNopermitida = new RegExp('[#A-Za-z_:$!%-({})/*=?|]');
    let expMenos = new RegExp('-');
    let expMas = new RegExp('[+]');     
    let expCadena = new RegExp('[0-9]');
    if (expCadena.test(e.target.value)&&!expNopermitida.test(e.target.value)&&!expMenos.test(e.target.value)&&
        !expMas.test(e.target.value)||e.target.value===' '||e.target.value==='') 
    {
      guardarHoraCierre({
        ...horaCierre,
        [e.target.name] : e.target.value  
      })
      if (aviso) 
      {
        setMensaje('');
        setAviso(false);
      }
    }
  };

  const onChange2 = e =>
  { let expNopermitida = new RegExp('[#_:$!%-({})/*=?|]');
    let expMenos = new RegExp('-');
    let expMas = new RegExp('[+]');     
    let expCadena = new RegExp('[A-Za-z0-9]');
    if (expCadena.test(e.target.value)&&!expNopermitida.test(e.target.value)&&!expMenos.test(e.target.value)&&
        !expMas.test(e.target.value)||e.target.value===' '||e.target.value==='') 
    {
      guardarHoraCierre({
        ...horaCierre,
        [e.target.name] : e.target.value  
      })
      if (aviso) 
      {
        setMensaje('');
        setAviso(false);
      }
    }
  };
  
  function verifHorario(auxHora)
  { let fec = moment(Horario);
    let auxNum =parseInt(fec.format("HH"));    
    return(auxNum )                       
  }

  const mostrarAlertas =(auxMensaje)=>{
    setTipoAdvertencia("warning")
    let mensaje=auxMensaje            
    setMensaje(mensaje);
    setAviso(true)   
  }

  function valNulos(auxMensaje,auxCampo) 
  {    let valida=false    
      if ( auxCampo !== '' && auxCampo !== '0' && auxCampo !==0 
          && auxCampo !== null && auxCampo!==" " ) 
      {   valida=true              
      }
      if (!valida) 
      {   mostrarAlertas(auxMensaje)
      }
      return valida
  }

  const guardarDatos = () => 
  {
    if (Horario!= '' &&Horario!= '0' && Horario!= null && verifHorario(Horario)>5&&verifHorario(Horario)<=23) 
    { if (Cabinas != ''&&Cabinas != '0') 
      { if (Pinzas != ''&& Pinzas != '0') 
        {   
          if (valNulos("Debe llenar el campo Incidencia Externa",Incidencia ) ) 
          {
            const fec = moment(Horario).format("HH:mm");                                              
            registrarCierre(fec)                         
          }    
        } 
        else 
        { mostrarAlertas("Debe llenar el campo Pinzas")          
        }
      }   
      else
      { mostrarAlertas("Debe llenar el campo Cabinas")        
      }   
    } 
    else 
    { mostrarAlertas("Debe seleccionar Hora de Termino")      
    }                           
  };


 /*    const guardarDatos = () => 
  {
    
    const fec = moment(Horario).format("HH:mm");                                      
    // registrarCierre(fec.format("HH:mm"))    
    const arrUsu= obtnUsu()         
    if (valListUsu() && arrUsu.length!==0) {
      setEditUsu(arrUsu) 
      registrarCierre(fec)    
    }
    else{
      registrarCierre(fec)    
    }           
                             
  }; */

  
  const onChangeInp = (e )=>
  { let expNopermitida = new RegExp('[#A-Za-z_:$!%-({})/*=?|]');
    let expMenos = new RegExp('-');
    let expMas = new RegExp('[+]');     
    let expCadena = new RegExp('[0-9]');
    if (expCadena.test(e.target.value) && !expNopermitida.test(e.target.value) && !expMenos.test(e.target.value) 
      && !expMas.test(e.target.value) || e.target.value===' '|| e.target.value==='') 
    {
      
      setUsuarios({...usuarios,[e.target.name] : e.target.value   })        
    }
  };

function Row() {
  
  return (  
  <TableRow className={classes.row}>        
    <TableCell component="th" scope="row" align="center" style={{ fontWeight:700,width:80+'px'}} padding={'none'}  >
     Total
    </TableCell>                
    <TableCell align="center" padding={'none'} style={{ width:50+'px'}}  >
      {totUsu.tp0Tot}
    </TableCell>
    <TableCell align="center" padding={'none'} style={{ width:50+'px'}}>
      {totUsu.tp1Tot}
    </TableCell>      
    <TableCell align="center" padding={'none'} style={{width: 75 + 'px'}}>
      {totUsu.tp2Tot}
    </TableCell>  
    <TableCell align="center" padding={'none'} style={{width: 75 + 'px'}}>
      {totUsu.tp3Tot}
    </TableCell>  
    <TableCell align="center" padding={'none'} style={{width: 75 + 'px'}}>
      {totUsu.tp4Tot}
    </TableCell>   
  </TableRow>          
  );
  }

  function tablaCompleta(auxlista){
    //console.log("entrando sin preguntar");
    return(
    <TableContainer className={classes.tablaContainer} id="tablaCompleta-paro" style={{width:"30rem"}}>
    <Table stickyHeader aria-label="sticky table">
      <TableHead>
        <TableRow  >          
          <TableCell style={{ color:colorFuente}} align="center" padding={'none'} >Estación</TableCell>          
          <TableCell style={{ color:colorFuente}} align="center" padding={'none'} >
            <img src='user_cobro2.svg' height={23} width={23}/> 
            <br/> Cobro</TableCell>
          <TableCell style={{ color:colorFuente}} align="center" padding={'none'} >
          <img src='abuelo.svg' height={23} width={23}/> 
          <br/> 3era Edad</TableCell>
          <TableCell style={{ color:colorFuente}} align="center" padding={'none'} >
          <img src='silla_ruedas.svg' height={23} width={23}/> 
          <br/>Disca...</TableCell>
          <TableCell style={{ color:colorFuente}} align="center" padding={'none'} >
          <img src='nino.png' height={23} width={23}/> 
          <br/>Niños</TableCell>
          <TableCell style={{ color:colorFuente}} align="center" padding={'none'} >
          <img src='otro.png' height={23} width={23}/> 
          <br/>Otro</TableCell>
          
        </TableRow>
      </TableHead>
      <TableBody>      
        <TableRow className={classes.row}>        
          <TableCell component="th" scope="row" align="center" style={{ fontWeight:700,width:80+'px'}} padding={'none'}  >
            {usuarios[`estacion${1}`]}
          </TableCell>                
          <TableCell align="center" padding={'none'} style={{ width:75+'px'}}  >
            <input type="text" id={`input-tp0Est1`} value={usuarios[`tp0Est1`]} name={`tp0Est1`} 
              onChange={onChangeInp}  style={{width:4+'rem',height:1.5+'rem',fontWeight:700}}
              maxlength={limitNumber}   />   
              
          </TableCell>
          <TableCell align="center" padding={'none'} style={{ width:75+'px'}}>
            <input type="text" id={`input-tp1Est1`} value={usuarios[`tp1Est1`]} name={`tp1Est1`}
              onChange={onChangeInp}  style={{width:4+'rem',height:1.5+'rem',fontWeight:700}}  
              maxlength={limitNumber}  />      
          </TableCell>      
          <TableCell align="center" padding={'none'} style={{width: 75 + 'px'}}>
            <input type="text" id={`input-tp2Est1`} value={usuarios[`tp2Est1`]} name={`tp2Est1`}
              onChange={onChangeInp}  style={{width:4+'rem',height:1.5+'rem',fontWeight:700}} 
              maxlength={limitNumber}  />      
          </TableCell>  
          <TableCell align="center" padding={'none'} style={{width: 75 + 'px'}}>
            <input type="text" id={`input-tp3Est1`} value={usuarios[`tp3Est1`]} name={`tp3Est1`}
              onChange={onChangeInp}  style={{width:4+'rem',height:1.5+'rem',fontWeight:700}}  
              maxlength={limitNumber}  />      
          </TableCell>  
          <TableCell align="center" padding={'none'} style={{width: 75 + 'px'}}>
            <input type="text" id={`input-tp4Est1`} value={usuarios[`tp4Est1`]} name={`tp4Est1`}
              onChange={onChangeInp}  style={{width:4+'rem',height:1.5+'rem',fontWeight:700}}
              maxlength={limitNumber}  />      
          </TableCell>  
        </TableRow> 
        <TableRow className={classes.row}>        
          <TableCell component="th" scope="row" align="center" style={{ fontWeight:700,width:80+'px'}} padding={'none'}  >
            {usuarios[`estacion${2}`]}
          </TableCell>                
          <TableCell align="center" padding={'none'} style={{ width:75+'px'}}  >
            <input type="text" id={`input-tp0Est2`} value={usuarios[`tp0Est2`]} name={`tp0Est2`}
              onChange={onChangeInp}  style={{width:4+'rem',height:1.5+'rem',fontWeight:700}}
              maxlength={limitNumber}  />      
          </TableCell>
          <TableCell align="center" padding={'none'} style={{ width:75+'px'}}>
            <input type="text" id={`input-tp1Est2`} value={usuarios[`tp1Est2`]} name={`tp1Est2`}
              onChange={onChangeInp}  style={{width:4+'rem',height:1.5+'rem',fontWeight:700}}
              maxlength={limitNumber}  />      
          </TableCell>      
          <TableCell align="center" padding={'none'} style={{width: 75 + 'px'}}>
            <input type="text" id={`input-tp2Est2`} value={usuarios[`tp2Est2`]} name={`tp2Est2`}
              onChange={onChangeInp}  style={{width:4+'rem',height:1.5+'rem',fontWeight:700}}
              maxlength={limitNumber}  />      
          </TableCell>  
          <TableCell align="center" padding={'none'} style={{width: 75 + 'px'}}>
            <input type="text" id={`input-tp3Est2`} value={usuarios[`tp3Est2`]} name={`tp3Est2`}
              onChange={onChangeInp}  style={{width:4+'rem',height:1.5+'rem',fontWeight:700}}
              maxlength={limitNumber}  />      
          </TableCell>  
          <TableCell align="center" padding={'none'} style={{width: 75 + 'px'}}>
            <input type="text" id={`input-tp4Est2`} value={usuarios[`tp4Est2`]} name={`tp4Est2`}
              onChange={onChangeInp}  style={{width:4+'rem',height:1.5+'rem',fontWeight:700}}
              maxlength={limitNumber}  />      
          </TableCell>  
        </TableRow>
        <TableRow className={classes.row}>        
          <TableCell component="th" scope="row" align="center" style={{ fontWeight:700,width:80+'px'}} padding={'none'}  >
            {usuarios[`estacion${3}`]}
          </TableCell>                
          <TableCell align="center" padding={'none'} style={{ width:75+'px'}}  >
            <input type="text" id={`input-tp0Est3`} value={usuarios[`tp0Est3`]} name={`tp0Est3`}
              onChange={onChangeInp}  style={{width:4+'rem',height:1.5+'rem',fontWeight:700}}
              maxlength={limitNumber}  />      
          </TableCell>
          <TableCell align="center" padding={'none'} style={{ width:75+'px'}}>
            <input type="text" id={`input-tp1Est3`} value={usuarios[`tp1Est3`]} name={`tp1Est3`}
              onChange={onChangeInp}  style={{width:4+'rem',height:1.5+'rem',fontWeight:700}}
              maxlength={limitNumber}  />      
          </TableCell>      
          <TableCell align="center" padding={'none'} style={{width: 75 + 'px'}}>
            <input type="text" id={`input-tp2Est3`} value={usuarios[`tp2Est3`]} name={`tp2Est3`}
              onChange={onChangeInp}  style={{width:4+'rem',height:1.5+'rem',fontWeight:700}}
              maxlength={limitNumber}  />      
          </TableCell>  
          <TableCell align="center" padding={'none'} style={{width: 75 + 'px'}}>
            <input type="text" id={`input-tp3Est3`} value={usuarios[`tp3Est3`]} name={`tp3Est3`}
              onChange={onChangeInp}  style={{width:4+'rem',height:1.5+'rem',fontWeight:700}}
              maxlength={limitNumber}  />      
          </TableCell>  
          <TableCell align="center" padding={'none'} style={{width: 75 + 'px'}}>
            <input type="text" id={`input-tp4Est3`} value={usuarios[`tp4Est3`]} name={`tp4Est3`}
              onChange={onChangeInp}  style={{width:4+'rem',height:1.5+'rem',fontWeight:700}}
              maxlength={limitNumber}  />      
          </TableCell>  
        </TableRow>      
        {totUsu.length!==0 ? <Row/> : null }        
      </TableBody>
    </Table>
    </TableContainer>
   )
  }

  return ( 
  <Modal
    titulo={titulo} modalAbierto={modalAbierto}
    setModalAbierto={setModalAbierto} guardarDatos={guardarDatos}
    mensaje={mensaje} tipoAdvertencia={tipoAdvertencia}
    aviso={aviso} setAviso={setAviso} espera={espera} btnCancelar={false}
  >
    <form className={classes.root} noValidate autoComplete="off" fullWidth>                    
      
      <Relojes horaApertura={horaCierre}  guardarHoraApertura={guardarHoraCierre}/>   
      <TextField id="input-cabina" label="Cabinas" size="small" type="number" variant='outlined'
          value={Cabinas} onChange={onChange} name="Cabinas" style={{width:6.5+'rem'}}
      />
      <TextField id="input-pinza" label="Pinzas" size="small" type="number" variant='outlined'
          value={Pinzas} onChange={onChange} name="Pinzas" style={{width:6.5+'rem'}}
      />
      <br/>
      
      <TextField id="input-usuarios" label="Incidencia Externa" size="small" type="text" variant='outlined'
          value={Incidencia} onChange={onChange2} name="Incidencia" style={{width:25+'rem'}}
      />
    {/*   <Box display={"flex"}  style={{width:"30rem"}}>
        {usuarios.length !== 0 ? tablaCompleta(usuarios) : null}
      </Box> */}
    {/*  <Box display={"flex"} flexDirection={"column"}>
      <Box display={"flex"} flexDirection={"row"} style={{marginRight:"1rem"}}>
      <TextField id="input-usuarios" label="Inc  " size="small" type="text"
          value={Incidencia} onChange={onChange2} name="Incidencia" style={{width:3+'rem'}}
      />
        <TextField id="input-usuarios" label="Inc  " size="small" type="text"
          value={Incidencia} onChange={onChange2} name="Incidencia" style={{width:3+'rem'}}
      />
        <TextField id="input-usuarios" label="Inc  " size="small" type="text"
          value={Incidencia} onChange={onChange2} name="Incidencia" style={{width:3+'rem'}}
      />
        <TextField id="input-usuarios" label="Inc  " size="small" type="text"
          value={Incidencia} onChange={onChange2} name="Incidencia" style={{width:3+'rem'}}
      />
        <TextField id="input-usuarios" label="Inc  " size="small" type="text"
          value={Incidencia} onChange={onChange2} name="Incidencia" style={{width:3+'rem'}}
      />
      </Box>
    
    
    </Box> */}
    </form>
  </Modal>
  );
}
 
export default EditarCierre;